export default {
  SETTINGS: `Ajustes`,
  MORE_OPTIONS: `Más`,
  VIDEO_PREVIEW: `Vista Previa`,
  HELP: `Ayuda`,
  VISIT_LINK_UNCLICKED: `Copiar Enlace`,
  VISIT_LINK_CLICKED: `¡Enlace Copiado!`,
  REPORT_ISSUE: `Reportar Problema`,
  FLIP: `Voltear`,
  SELECTED: `seleccionada`,
  GRID_VIEW: `Ver Tabla`,
  SINGLE_VIEW: `Vista Individual`,
  LEAVE: 'Salir',
  MUTE: 'Silencio',
  UNMUTE: 'Silencio',
  START_VIDEO: 'Iniciar Video',
  STOP_VIDEO: 'Detener Video',
  FLIP_TO_FRONT: `Voltear al Frente`,
  FLIP_TO_BACK_BUTTON: `Voltear Atrás`,
  DEVICE_SETTINGS: `Configurar Dispositivo`,
  CHAT: `Chat`,
  OPEN_CHAT_BUTTON: `Abrir Chat`,
  NEW_CHAT_BUTTON: `Nuevo Chat`,
  RECONNECT: 'Reconectar',

  CALL_SCREEN_LEAVE_CONFIRMATION_HEADER: `Dejar la Llamada`,
  CALL_SCREEN_LEAVE_CONFIRMATION_CONTENT: `¿Estás seguro de que quieres salir de tu visita de telesalud?`,
  CALL_SCREEN_LEAVE_CALL_BUTTON: `Dejar`,
  CALL_SCREEN_LEAVE_STAY_ON_CALL_BUTTON: `Permanecer`,
};
